import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client/core';
import { ApolloProvider as BaseApolloProvider } from '@apollo/client/react';
import { ReactNode, useMemo } from 'react';

import { useAppConfig } from './app-config-provider';

function createApolloClient(graphqlUrl: string) {
  const httpLink = createHttpLink({
    uri: graphqlUrl,
    credentials: 'include',
  });

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
  });
}

interface ApolloProviderProps {
  children: ReactNode;
}

export function ApolloProvider({ children }: ApolloProviderProps) {
  const { config } = useAppConfig();
  const client = useMemo(
    () => createApolloClient(config.graphqlUrl),
    [config.graphqlUrl],
  );

  return <BaseApolloProvider client={client}>{children}</BaseApolloProvider>;
}
